import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  useTheme
} from '@mui/material';
import { errorStyles } from '../../styles/locationCampaign/error';
import background from '../../assets/images/location_campaign/lemn.png';
import kozel from '../../assets/images/location_campaign/logo.png';
import despre_alcool from '../../assets/images/promo-despre-alcool.png';
import linie1 from '../../assets/images/location_campaign/linie1.png';
import tap from '../../assets/images/location_campaign/logo2.png';

interface ErrorProps {
  onNext: () => void;
}

export default function Error({ onNext }: ErrorProps) {
  const theme = useTheme();

  const handleTryAgain = () => {
    onNext();
  };

  return (
    <Box sx={errorStyles.container}>
      <Paper elevation={0} sx={errorStyles.paper(background)}>
          {/* Header */}
          <Box sx={errorStyles.header}>
            <Box
              component="img"
              src={kozel}
              alt="Kozel"
              sx={errorStyles.logo}
            />
          </Box>

          <Box sx={errorStyles.content}>
            {/* Main Title */}
            <Typography variant="h1" sx={errorStyles.mainTitle(theme)}>
              UPSSSS!
            </Typography>

            {/* Instructions */}
            <Box sx={errorStyles.instructions}>
              <Typography variant="body1" sx={errorStyles.instructionsText}>
                Acest bon a fost deja inscris!
              </Typography>
            </Box>
              
            <Box sx={errorStyles.prizeContent}>
              <Box
                component="img"
                src={tap}
                alt="logo"
                sx={errorStyles.logoTap}
              />
            </Box>

            {/* Linia 1 - înainte de input */}
            <Box sx={errorStyles.lineContainer}>
              <Box
                component="img"
                src={linie1}
                alt="Linia 1"
                sx={errorStyles.lineImage}
              />
            </Box>

            <Typography variant="h6" sx={errorStyles.text}>
             Verifică să fie corect sau încearcă cu un alt bon valid. Poți înscrie până la 5 bonuri pe zi.
            </Typography>

            {/* Linia 2 - după input */}
            <Box sx={errorStyles.lineContainer}>
              <Box
                component="img"
                src={linie1}
                alt="Linia 2"
                sx={errorStyles.lineImage}
              />
            </Box>

            {/* Try Again Button */}
            <Box sx={errorStyles.buttonContainer}>
              <Button
                variant="contained"
                onClick={handleTryAgain}
                sx={errorStyles.continueButton}
              >
                ÎNCEARCĂ DIN NOU
              </Button>
            </Box>

            {/* Footer Info */}
            <Box sx={errorStyles.footer}>
              <Typography variant="caption" sx={errorStyles.footerText}>
                Campania se desfășoară doar în locațiile selectate de organizator
              </Typography>
              
              <Box sx={errorStyles.footerImageContainer}>
                <Box
                  component="img"
                  src={despre_alcool}
                  alt="Despre alcool"
                  sx={errorStyles.footerImage}
                />
              </Box>
            </Box>
          </Box>
        </Paper>
    </Box>
  );
}